import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/fermentations/procedures/$procedure_id/",
)({
  component: () => {
    const { procedure_id } = Route.useParams();
    return (
      <Navigate
        to="/fermentations/procedures/$procedure_id/overview"
        params={{ procedure_id }}
        replace
      />
    );
  },
});
